import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useGetSuppCategoryList, useGetSuppList } from "../../../../interface/supplies";
import theme from '../../../../styles/theme';
import moment from 'moment';
import CommonDataGrid from '../../../common/CommonDataGrid';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import FullModal from '../../../common/modal/FullModal';
import Detail from './Detail';
import { availCheck } from '../inout/common';
import { useQuery } from 'react-query';
import Button from '../../../common/Button';

const MainWrap = styled.div`
    padding: 0.25rem 1.5rem; 
    display: flex;
    flex-direction: column;
    
    div {
        color: ${theme.color.black};
        font-size: ${theme.fontSize.base};
    }
    transition: ${theme.windowSize.drawerTransition};
`;

const columns = [
    { field: 'cat_nm', headerName: '분류', width:90 },
    { field: 'model_nm', headerName: '모델명', width:200 },
    { field: 'model_sub', headerName: '모델유형', width:120 },
    { field: 'lot_no', headerName: '표기번호', width:120 },
    { field: 'spec', headerName: '사양', width:120 },
    { field: 'pur_date', headerName: '구매일자', width:100 },
    { field: 'sup_cdnm', headerName: '소모품용도', width:100 },
    { field: 'sup_stnm', headerName: '소모품상태', width:100 },
    { field: 'use_dt', headerName: '최초사용일시', width:100 },
    { field: 'end_dt', headerName: '최종사용일시', width:100 },
    { field: 'user_nm', headerName: '사용자', width:100 },
]

const Supplies = () => {

    const [list, setList] = useState([]);
    const [category, setCategory] = useState('');

    const [regOpen, setRegOpen] = useState(false);
    const [target, setTarget] = useState();

    const { data : user } = useQuery('ADMIN_USER_INFO', {});

    const { data: suppList, isLoading: suppLoading, refetch: suppRefetch } = useGetSuppList({cid:category});
    const { data: suppCateList, isLoading: suppCateLoading } = useGetSuppCategoryList();

    useEffect(()=>{
        if(suppList){
            setList(suppList.map((item,index)=>(
                                    {
                                        ...item,
                                        id:index,
                                        pur_date: item.pur_date ? moment(item.pur_date).format('YYYY/MM/DD') : '',
                                        use_dt: item.use_dt ? moment(item.use_dt).format('YYYY/MM/DD') : '',
                                        end_dt: item.end_dt ? moment(item.end_dt).format('YYYY/MM/DD') : '',
                                    }
                                )));
        }else{
            setList([])
        }
    },[suppList])

    useEffect(()=>{
        suppRefetch();
    },[category])

    return (
        <MainWrap>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'baseline'}}>
                <FormControl style={{width:'10rem',margin:'8px 0px 16px 0px'}} size='small'>
                    <InputLabel id='cateogry-label'>분류</InputLabel>
                    <Select label="분류" labelId='cateogry-label' size='small' value={category}>
                        <MenuItem value={''} onClick={()=>setCategory('')} >없음</MenuItem>
                        {suppCateList && suppCateList[0].map((item,index)=>{
                            return <MenuItem 
                                        key={index} 
                                        value={item.cid} 
                                        onClick={()=>setCategory(item.cid)}
                                    >
                                        {item.cat_nm}
                                    </MenuItem>
                        })}
                    </Select>
                </FormControl>
                {availCheck(user.user_tp) && <Button onClick={()=>{setTarget();setRegOpen(true)}} style={{width:'120px'}}>등록</Button>}
            </div>
            <div style={{width:'100%', height: '82vh'}}>
                <CommonDataGrid
                    isLoading={suppLoading}
                    list={list}
                    columns={columns}
                    checkBox={true}
                    showCount={100}
                    onRowClick={(e)=>{setTarget(e.row);setRegOpen(true)}}
                    />
            </div>
            <FullModal open={regOpen}>
                <DetailWrap target={target} onClose={setRegOpen} />
            </FullModal>
        </MainWrap>
    )
}

const DetailWrapStyle = styled.div`
    width: 100%;
    height: 100%;
    // border: 1px solid red;
`;

const DetailWrap = ({target, onClose}) => {
    return (
        <DetailWrapStyle>
            <Detail item={target} onClose={onClose}/>
        </DetailWrapStyle>
    )
}

export default Supplies;